<template lang="html">
  <masked-input
    type="text"
    class="text-left form-control"
    :class="customClass"
    :id="id"
    v-model="phone"
    @change="callChange"
    @keyup="callKeyUp"
    :placeholder="placeholder"
    :mask="setPhoneNumber"
    :guide="false"
  />
</template>

<script>
import MaskedInput from 'vue-text-mask';

export default {
  name: 'input-mask',
  components: {
    MaskedInput,
  },
  props: {
    placeholder: {
      type: String,
      default: '(00) 00000-0000',
    },
    model: {
      required: true,
      default: null,
    },
    id: {
      type: String,
      default: '',
    },
    state: {
      type: Boolean,
      default: null,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    onKeyup: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    phone: {
      get() {
        return this.model;
      },
      set(val) {
        this.$emit('update:model', val);
      },
    },
    customClass() {
      if (this.state === null) return null;
      const valid = this.state ? 'is-valid' : 'is-invalid';
      return valid;
    },
  },
  mounted() {
    this.phone = this.model;
  },
  methods: {
    callChange(e) {
      this.$emit('change', e.target.value);
      this.onChange(this.model);
    },
    callKeyUp() {
      this.onKeyup(this.model);
    },
    setPhoneNumber(rawValue) {
      if (rawValue.length < 15) {
        return ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
      return ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    },
  },
};
</script>
